import { __rest } from "tslib";
import classNames from 'classnames';
import { createElement, forwardRef } from 'rax';
import List from '../list';
import View from '../view';
const FormGroup = (props, ref) => {
    const { prefix = 'mt-', className, children } = props, other = __rest(props, ["prefix", "className", "children"]);
    return (<View ref={ref} className={`${prefix}form-group`}>
      <List {...other} className={classNames(`${prefix}form-group-list`, className)}>
        {children}
      </List>
    </View>);
};
export default forwardRef(FormGroup);
